import { UIEvent } from 'react';

import { Box } from '@grupoboticario/flora-react';
import { getLocalAssetUrl } from 'core/utilities';

import Styles from './Carousel.styles';

import type { ImageObject } from 'core/services/bff';

type ThumbnailProps = {
  thumbnail: ImageObject[];
  controlList: any;
  state: any;
  openModal: () => void;
};

const LIMIT_SHOW_THUMBNAIL = 5;
const INDEX_THUMBNAIL = 4;

const ThumbnailBase = ({ thumbnail = [], controlList, state, openModal }: ThumbnailProps) => {
  const countThumbnail = Object.keys(thumbnail).length;

  if (countThumbnail < 1) {
    return <></>;
  }

  const handleClickZoom = (event: UIEvent<HTMLButtonElement>) => {
    controlList.scrollTo(event);

    openModal();
  };

  return (
    <Box data-testid="product-thumbnails">
      {thumbnail
        ?.filter((_, index) => index < INDEX_THUMBNAIL)
        ?.map((image, index) => {
          return (
            <Styles.Thumbnail
              data-testid={`thumbnail-img-${index}`}
              key={`thumbnail-img${index}`}
              data-index={index}
              data-active={index === Number(state.page) ? true : false}
              onClick={controlList.scrollTo}
            >
              <img
                src={image?.small}
                key={image?.thumbnail}
                onError={({ currentTarget }) => {
                  currentTarget.onerror = null; // prevents looping
                  currentTarget.src = getLocalAssetUrl('/images/placeholder.jpg');
                }}
              />
            </Styles.Thumbnail>
          );
        })}

      {countThumbnail > LIMIT_SHOW_THUMBNAIL && (
        <Styles.Thumbnail
          key={`thumbnail-img${INDEX_THUMBNAIL}`}
          data-index={INDEX_THUMBNAIL}
          data-active={INDEX_THUMBNAIL === Number(state.page) ? true : false}
          onClick={handleClickZoom}
        >
          <img
            src={thumbnail[INDEX_THUMBNAIL]?.small}
            key={thumbnail[INDEX_THUMBNAIL]?.thumbnail}
            onError={({ currentTarget }) => {
              currentTarget.onerror = null; // prevents looping
              currentTarget.src = getLocalAssetUrl('/images/placeholder.jpg');
            }}
          />
          <Styles.Count>+ {countThumbnail - INDEX_THUMBNAIL}</Styles.Count>
        </Styles.Thumbnail>
      )}
    </Box>
  );
};

export default ThumbnailBase;
